import { render, staticRenderFns } from "./insuranceConsultation.vue?vue&type=template&id=401c8082&scoped=true&"
import script from "./insuranceConsultation.vue?vue&type=script&lang=js&"
export * from "./insuranceConsultation.vue?vue&type=script&lang=js&"
import style0 from "./insuranceConsultation.vue?vue&type=style&index=0&id=401c8082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401c8082",
  null
  
)

export default component.exports